import { Box } from "@jewlr/storybook/core"
import { FloatInput } from "@jewlr/storybook/form"
import PropTypes from "prop-types"
import React from "react"
import { Controller } from "react-hook-form"
import styled from "styled-components"

const GiftCardFieldBox = styled(FloatInput)`
  border: solid 1px ${(props) => props.theme.colors.grey[35]};
`
const GiftCardDarkField = ({ control, label, name, placeholder, type }) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <Box flexBasis={{ tablet: "100%" }}>
          <GiftCardFieldBox
            error={error}
            label={label}
            mb="0"
            p="0"
            placeholder={placeholder}
            {...field}
          />
        </Box>
      )}
      type={type}
    />
  )
}

GiftCardDarkField.propTypes = {
  control: PropTypes.object,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
}

export default GiftCardDarkField
